// Quadpay widget styling - only runs on non-product pages
if (!window.location.pathname.includes('products')) {
  function applyQuadpayStyles() {
    document.querySelectorAll("quadpay-widget-v3").forEach((widget) => {
      if (widget.shadowRoot) {
        const shadowRoot = widget.shadowRoot;

        // Apply global styles inside quadpay-widget-v3
        if (!shadowRoot.querySelector("style[data-global-style]")) {
          const globalStyle = document.createElement("style");
          globalStyle.textContent = `
            .qp-info-icon {
              margin-top: 0 !important;
            }
            .qp-container {
              padding: 0 0 10px 0 !important;
              box-sizing: border-box;
            }
          `;
          globalStyle.setAttribute("data-global-style", "true");
          shadowRoot.appendChild(globalStyle);
        }

        // Apply .qp-container styles ONLY inside .slider-section
        const parentSection = widget.closest(".hb_pls-main");

        if (parentSection && !shadowRoot.querySelector("style[data-slider-style]")) {
          const sliderStyle = document.createElement("style");
          sliderStyle.textContent = `
            .qp-container {
              padding: 0 10px 10px 10px !important;
              box-sizing: border-box;
            }
          `;
          sliderStyle.setAttribute("data-slider-style", "true");
          shadowRoot.appendChild(sliderStyle);
        }

        // Apply styles inside quadpay-logo shadowRoot
        const qpLogo = shadowRoot.querySelector("quadpay-logo");
        if (qpLogo && qpLogo.shadowRoot) {
          if (!qpLogo.shadowRoot.querySelector("style[data-logo-style]")) {
            const logoStyle = document.createElement("style");
            logoStyle.textContent = `
              #qp-logo-svg {
                width: 40px !important;
              }
              .qp-logo--last {
                margin: 0 6px !important;
              }
            `;
            logoStyle.setAttribute("data-logo-style", "true");
            qpLogo.shadowRoot.appendChild(logoStyle);
          }
        }
      }
    });
  }

  // Observe changes and apply styles dynamically
  const observer = new MutationObserver(() => {
    applyQuadpayStyles();
  });

  // Start observing the whole document to detect new Quadpay widgets
  observer.observe(document.body, { childList: true, subtree: true });

  // Run initially
  applyQuadpayStyles();
}
